.block,
.line {
  display: block;
  border-radius: var(--radius-tag);
  background: var(--fill);
}

.lines {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.line {
  height: var(--space-3);
}

.line:last-child:not(:first-child) {
  inline-size: 62%;
}
